import React from 'react';
import CtaSidebar from './CtaSidebar';

const PageContent = props => (
  <div>
    <div className="business-banner">
      <div className="hvrbox">
        <img src="/images/_bg/02.jpg" alt="Team" className="hvrbox-layer_bottom" />
        <div className="hvrbox-layer_top">
          <div className="container">
            <div className="overlay-text text-left">
              <h3>{props.content.heading}</h3>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    <a href={props.content.url}>{props.content.heading}</a>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bussiness-about-company">
      <div className="container">
        <div className="row">
          <div className="col-md-9">
            <div className="about-company-left">
              {/* <img src="/images/bg-3.jpg" alt="Logo" /> */}
              <h2>{props.content.title}</h2>
              <h3>{props.content.desc}</h3>
              <div className="padding-top-middle" />
              <div dangerouslySetInnerHTML={{ __html: props.content.body }} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="about-company-right">
              <div className="padding-top-middle" />

              <CtaSidebar cta={props.cta} />

              <div className="padding-top-middle" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
export default PageContent;



// WEBPACK FOOTER //
// ./src/components/PageContent.js